import { useQuery } from '@tanstack/react-query';

import apiClient from '../../lib/api-client';

export const productFacetsKeys = {
  all: ['product-facets'] as const,
};

export interface ProductFacets {
  /** Distinct raw ARW annuity-type codes present in the active catalog. */
  annuityTypes: string[];
  /** Distinct surrender periods (years) present in the active catalog. */
  surrenderPeriods: number[];
}

async function fetchProductFacets(): Promise<ProductFacets> {
  const response = await apiClient.get<ProductFacets>('/products/facets');
  return {
    annuityTypes: response.data.annuityTypes ?? [],
    surrenderPeriods: response.data.surrenderPeriods ?? [],
  };
}

/**
 * Catalog-wide filter facets (product types and surrender periods) used to
 * populate the Type and Surrender filter dropdowns on the opportunity
 * comparison table. Sourced from the whole active catalog rather than the
 * products currently displayed.
 */
export function useProductFacets() {
  return useQuery({
    queryKey: productFacetsKeys.all,
    queryFn: fetchProductFacets,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
